import { render, staticRenderFns } from "./Residentials.vue?vue&type=template&id=4637464a"
import script from "./Residentials.vue?vue&type=script&lang=js"
export * from "./Residentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports